import GastroPancolonscopiaList from "./pages/GastroPancolonscopiaList.vue"
import GastroPancolonscopiaView from "./pages/GastroPancolonscopiaView.vue"
import GastroPancolonscopiaEdit from "./pages/GastroPancolonscopiaEdit.vue"

export default{
    GastroPancolonscopiaList,
    GastroPancolonscopiaView,
    GastroPancolonscopiaEdit,
}